import * as Autobatcher from 'models/Autobatcher';
import {getModelManager, ManagedModelType} from 'models/ManagedModelDefinitions';

/**
 * Function for legacy usage; use DataConnector for new usages.
 */
export default function requestFetchValidationExtras(
  bioentityId: string,
  {forceFetch}: Autobatcher.requestFetchOptions = {forceFetch: false}
): void {
  Autobatcher.requestFetch(getModelManager(ManagedModelType.VALIDATION_EXTRAS_BY_BIOENTITY_ID), bioentityId, {
    forceFetch,
  });
}
